export default "__VITE_ASSET__ca5110e7__"